import HomeSmileIcon from 'src/icons/untitled-ui/duocolor/home-smile';
import Users03Icon from 'src/icons/untitled-ui/duocolor/users-03';
import Car01Icon from 'src/icons/untitled-ui/free/car-01';
import ReceiptCheckIcon from 'src/icons/untitled-ui/duocolor/receipt-check';
import Tool02Icon from 'src/icons/untitled-ui/free/tool-02';
import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import Upload04Icon from 'src/icons/untitled-ui/duocolor/upload-04';

export const leaderSections = (t, tokens, paths, SvgIcon, perms) => {
  const { hideFuel = false } = perms;
  // Dynamic section for fuel
  const fuelSection = 
    (hideFuel) ? [] : [
          {
            title: t(tokens.nav.fuel),
            path: paths.fuels.index,
            icon: (
              <SvgIcon fontSize="small">
                <ReceiptCheckIcon />
              </SvgIcon>
            ),
          },
        ];

  return [
    {
      items: [
        {
          title: t(tokens.nav.overview),
          path: paths.dashboard.index,
          icon: (
            <SvgIcon fontSize="small">
              <HomeSmileIcon />
            </SvgIcon>
          ),
        },
       
        {
          title: t(tokens.nav.tms),
          path: paths.tms.index,
          icon: (
            <SvgIcon fontSize="small">
              <AccessTimeOutlinedIcon />
            </SvgIcon>
          ),
        },
        ...fuelSection,
        {
          title: t(tokens.nav.repair),
          path: paths.repairs.index,
          icon: (
            <SvgIcon fontSize="small">
              <Tool02Icon />
            </SvgIcon>
          ),
        },
        
        {
          title: t(tokens.nav.workSchedule),
          path: paths.schedules.work.index,
          icon: (
            <SvgIcon fontSize="small">
              <EventOutlinedIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.repairRequest),
          path: paths.repairs.requests,
          icon: (
            <SvgIcon fontSize="small">
              <BuildCircleOutlinedIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.teachers),
          path: paths.teachers.index,
          icon: (
            <SvgIcon fontSize="small">
              <Users03Icon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.carManagement),
          path: paths.cars.index,
          icon: (
            <SvgIcon fontSize="small">
              <Car01Icon />
            </SvgIcon>
          ),
        },
        // {
        //   title: t(tokens.nav.fileManager),
        //   path: paths.assets.index,
        //   icon: (
        //     <SvgIcon fontSize="small">
        //       <Upload04Icon />
        //     </SvgIcon>
        //   ),
        // },
      ],
    },
  ];
};
